

























import { Vue, Component, Prop } from "vue-property-decorator";
import EnterpriseDetails from "../components/Profile/EnterpriseDetails.vue";
import UserDetails from "../components/Profile/UserDetails.vue";
import StudentDetails from "../components/Profile/StudentDetails.vue";
import InstituteDetails from "../components/Profile/InstituteDetails.vue";
import PrivacyDialog from "../components/Dialogs/PrivacyDialog.vue";
import * as user from "../_store/user.module";
import * as auth from "../_store/auth.module";
import { bus } from "../main";
import { UserInfo } from "../_models/userInfo";
import { StudentInfo } from "../_models/studentInfo";
import { InstituteInfo } from "../_models/instituteInfo";
import { router } from "../_router";
import {
  dispatchSetInstituteInfo,
  readStudentInfo,
  readInstituteInfo
} from "../_store/user.module";
import { userUtils } from "../_utils";
import { EnterpriseInfo } from "../_models/enterpriseInfo";
import * as temp from "../_store/temp.module"

@Component({
  components: {
    EnterpriseDetails,
    UserDetails,
    InstituteDetails,
    StudentDetails,
    PrivacyDialog
  }
})
export default class Profile extends Vue {
  @Prop() checkComplete!: string;
  private userData: UserInfo;
  private studentData: StudentInfo;
  private status: string;
  private instituteData: InstituteInfo;
  private checkInfo: boolean;

  constructor() {
    super();
    this.userData = {
      tipoSoggetto: 0,
      ruoloUtente: [],
      descrizioneRuolo: [],
      nomeUtente: "",
      cognomeUtente: "",
      indirizzoUtente: "",
      telefono1Utente: "",
      telefono2Utente: "",
      cod: "",
      dataNascita: "",
      luogoNascita: "",
      emailUtente: "",
      pecUtente: "",
      comuneUtente: "",
      provinciaUtente: "",
      entità: "",
      codEntità: 0,
      idCap: 0,
      idUtente: 0,
      cap: "",
      username: ""
    };
    this.studentData = {
      tipoSoggetto: 0,
      matricola: "",
      ruoloUtente: [],
      descrizioneRuolo: [],
      nomeUtente: "",
      cognomeUtente: "",
      indirizzoUtente: "",
      telefono1Utente: "",
      telefono2Utente: "",
      cod: "",
      dataNascita: "",
      luogoNascita: "",
      emailUtente: "",
      pecUtente: "",
      comuneUtente: "",
      provinciaUtente: "",
      entità: "",
      codEntità: 0,
      idCap: 0,
      idUtente: 0,
      cap: "",
      username: "",
      classe: "",
      idClasse: 0,
      idNazioneNascita: "",
      diplomato: false,
      dataDiploma: "",
      urlCV: ""
    };
    this.instituteData = {
      id: 0,
      ragioneSocialeIstituto: "",
      indirizzoIstituto: "",
      capComuneIstituto: "",
      provinciaIstituto: "",
      nazioneIstituto: "",
      comuneIstituto: "",
      telefono1Istituto: "",
      telefono2Istituto: "",
      emailIstituto: "",
      pecIstituto: "",
      codIstituto: "",
      codMinisterialeIstituto: "",
      dirigenteIstituto: ""
    };
    this.status = "";
    this.checkInfo = false;
  }

  get userInfo() {
    this.userData = user.readUserInfo(this["$store"]);
    return this.userData;
  }

  get studentInfo() {
    this.studentData = user.readStudentInfo(this["$store"]);
    return this.studentData;
  }

  parseToken(token: string): JSON {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function(c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
    return JSON.parse(jsonPayload);
  }

  created() {
    if (this.checkComplete === "true") {
      this.checkInfo = true;
    }
    var token = localStorage.getItem("userToken");
    var userStatus = localStorage.getItem("userStatus");
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"])
    var parsedToken: any;
    if (token !== null) {
      parsedToken = this.parseToken(token);
    }
    if (userStatus !== null) {
      this.status = userStatus;
      bus.$emit("loggedIn", this.status);
    }
    var payload = {
      idUtente: parsedToken.IdUtente,
      tipoSoggetto: parsedToken.IdTipoSoggetto,
      username: parsedToken.Username
    };
    if (payload.tipoSoggetto === 4) {
      user
        .dispatchSetStudentInfo(this["$store"], payload)
        .then(response => {
          this.studentData = response;
          // dispatchSetInstituteInfo(this["$store"]).then(() =>{
          //   this.instituteData = readInstituteInfo(this["$store"])

          // })
          bus.$emit("loadMenu");
        })
        .catch(error => {
          bus.$emit("stopLoading");
          auth.dispatchLogout(this["$store"]);
          user.dispatchClearState(this["$store"]);
          this["$router"].push("/sessionExpired");
        });
    } else {
      user
        .dispatchSetUserInfo(this["$store"], payload)
        .then(response => {
          this.userData = response;
          bus.$emit("loadMenu");
        })
        .catch(error => {
          bus.$emit("stopLoading");
          auth.dispatchLogout(this["$store"]);
          user.dispatchClearState(this["$store"]);
          this["$router"].push("/sessionExpired");
        });
    }

    bus.$on("editedUser", () => {
      this.userData = user.readUserInfo(this["$store"]);
    });

    // bus.$on("editedStudent", () => {
    //   this.studentData = user.readStudentInfo(this["$store"]);
    // });
  }
}
